import { render } from "./excess_item_details.vue?vue&type=template&id=0c941305&scoped=true"
import script from "./excess_item_details.vue?vue&type=script&lang=js"
export * from "./excess_item_details.vue?vue&type=script&lang=js"

import "./excess_item_details.vue?vue&type=style&index=0&id=0c941305&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c941305"]])

export default __exports__